import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BookingForm from "@/components/BookingForm";
import MobileBookCTA from "@/components/MobileBookCTA";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

const useQuery = () => new URLSearchParams(useLocation().search);

const BookingPage = () => {
  const { t } = useLanguage();
  const query = useQuery();
  const roomQuery = query.get("room") || "";
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    api.get("/rooms").then((r) => setRooms(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="booking-page" className="min-h-screen bg-[#FDFBF7]">
      <SEO page="booking" />
      <Header />
      <section className="pt-32 lg:pt-44 pb-20">
        <div className="container-mag">
          <div className="max-w-2xl mb-12">
            <div className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#1E3B2E] mb-4">{t("booking.kicker")}</div>
            <h1 className="display-lg">{t("booking.title")}</h1>
            <p className="body-prose mt-5">{t("booking.subtitle")}</p>
          </div>
          <BookingForm defaultRoomId={roomQuery} rooms={rooms} />
        </div>
      </section>
      <Footer />
      <MobileBookCTA />
      <WhatsAppButton />
    </div>
  );
};

export default BookingPage;
